import groq from 'groq'

export const getBlogPostsListQuery = groq`
  *[_type == "blogPost" && language == $language] | order(releaseDate desc) {
    _createdAt,
    _id,
    _updatedAt,
    author,
    authorAvatar,
    content,
    ingress,
    landscapeImage,
    quadraticImage,
    slug,
    title,
    releaseDate,
  }
`

export const getBlogPostDetailQuery = groq`
  *[_type == "blogPost" && language == $language && slug.current == $slug][0] {
    _createdAt,
    _id,
    _updatedAt,
    author,
    authorAvatar,
    content,
    landscapeImage,
    metaDescription,
    title,
    releaseDate,
    "localeSlugs": *[_type == "blogPost" && defined(key) && key == ^.key]{ language, "slug": slug.current },
  }
`
